import { CreditCheckResponse, CustomerCreditCheckModel } from 'src/typings/api-models/creditCheck'
import { ActionType, createAsyncAction } from 'typesafe-actions'

const actions = {
  getCustomerInformation: createAsyncAction(
    '[CustomerCreditCheckModel] GetCustomerInformation // REQUEST',
    '[CustomerCreditCheckModel] GetCustomerInformation // SUCCESS',
    '[CustomerCreditCheckModel] GetCustomerInformation // FAILURE'
  )<string, CustomerCreditCheckModel, {}>(),

  postCreditCheckForm: createAsyncAction(
    '[CreditCheckResponse] PostCreditCheckForm // REQUEST',
    '[CreditCheckResponse] PostCreditCheckForm // SUCCESS',
    '[CreditCheckResponse] PostCreditCheckForm // FAILURE'
  )<CustomerCreditCheckModel, CreditCheckResponse, {}>()
}

export type CreditCheckActions = ActionType<typeof actions>

export default actions



// WEBPACK FOOTER //
// ./src/store/creditCheck/actions.ts